module.exports = __webpack_public_path__ + "assets/img/1810.a6def867.svg";